export var query = "mutation markCheckoutAsCompleted($id: String!, $orderId: String) {\n  checkout {\n    markCheckoutAsCompleted(id: $id, orderId: $orderId)\n  }\n}\n";
//# sourceMappingURL=markCheckoutAsCompleted.graphql.js.map